export default {
  originDomainName: {
    title: 'Origin Domain Name',
    message: 'Specify the domain name or IP for your origin - the captain Ceph storage or web server from which you want CDN to get your web content.',
  },
  originPath: {
    title: 'Origin Path',
    message: 'If you want CDN to request your content from a directory in your your configured origin, enter the directory name here, beginning with a /. Do not include a / at the end of the directory name.',
  },
  originId: {
    title: 'Origin ID',
    message: 'In order to distinguish multiple origins in the same distribution from each other, you can enter a unique description for the Origin.',
  },
  originCustomHeaders: {
    title: '',
    message: 'If you want CDN to add custom headers whenever it sends a request to your origin, specify the following values: <br/><br/>Header Name <br />The name of a header that you want CDN to add to requests that it sends to your origin. <br/> <br/>Value <br/>The value for the header that you specified in the Custom Header field.',
  },
  pathPattern: {
    title: 'Path Pattern',
    message: 'The default cache behavior only allows a path pattern of * (forward all requests to the origin specified by Origin). To change the behavior or the routing for other requests (for example, *.jpg), add more cache behaviors after you create the distribution.',
  },
  viewerProtocolPolicy: {
    title: 'Viewer Protocol Policy',
    message: 'You can choose if you want CDN to allow viewers to access your web content using HTTP and HTTPS,  Redirect HTTP to HTTPS, or only HTTPS.',
  },
  allowedHttpMethods: {
    title: 'Allowed HTTP Methods',
    message: 'You can select the list of HTTP methods you want to allow for this cache behavior',
  },
  cachedHttpMethods: {
    title: 'Cached HTTP Methods',
    message: 'Select the list of HTTP methods you want to cache for this cache behavior',
  },
  cacheAndOriginRequestSettings: {
    title: 'Cache and Origin Request Settings',
    message: 'Specify if you want to use a cache policy and origin request policy or if you want to use legacy cache settings. We recommend using cache policy and origin request policy.',
  },
  cachePolicy: {
    title: 'Cache Policy',
    message: 'Choose a cache policy. A cache policy specifies the values in the cache key. It also specifies the time to live (TTL) values for objects in the cache.',
  },
  cnames: {
    title: 'Alternate Domain Names (CNAMEs)',
    message: 'You can list any custom domain names that you use in addition to the CDN domain name for the URLs for your files. You must create a CNAME record with your DNS service. ',
  },
  originGroups: {
    title: 'Origin Groups',
    message: 'View the CDN cache policies in your CDN account. Choose a cache policy to view or modify its settings.',
  },
  originProtocolPolicy: {
    title: 'Origin Protocol Policy',
    message: 'Select whether you want Cdn to connect to your origin using only HTTP, only HTTPS, or to connect by matching the protocol used by the viewer. For example, if you select Match Viewer for the Origin Protocol Policy, and if the viewer connects to Cdn using HTTPS, Cdn will connect to your origin using HTTPS.',
  },
  originRequestPolicies: {
    title: 'Origin Request Policies',
    message: 'View the CDN origin request policies in your CDN account. Choose an origin request policy to view or modify its settings.',
  },
  minimumTTL: {
    title: 'Minimum TTL',
    message: 'The minimum amount of time, in seconds, that objects stay in the CDN cache before CDN forwards another request to the origin to see if the object has been updated.',
  },
  maximumTTL: {
    title: 'Maximum TTL',
    message: 'The maximum amount of time, in seconds, that objects stay in the CDN cache before CDN forwards another request to the origin to see if the object has been updated.',
  },
  defaultTTL: {
    title: 'Default TTL',
    message: 'The default amount of time, in seconds, that you want objects to stay in CDN caches before CDN forwards another request to your origin to determine whether the object has been updated. The value that you specify applies only when your origin does not add HTTP headers such as Cache-Control max-age, Cache-Control s-maxage, and Expires to objects.',
  },
  browserMinimumTTL: {
    title: 'Browser Minimum TTL',
    message: 'Minimum value for browser caching. If you specify a value less than the minimum the CDN will clamp it to this value.',
  },
  browserMaximumTTL: {
    title: 'Browser Maximum TTL',
    message: 'Maximum value for browser caching. If you specify a value larger than the maximum, the CDN will clam it to this value.',
  },
  browserDefaultTTL: {
    title: 'Browser Default TTL',
    message: 'Default value for browser caching. If the origin does not send any header for caching on the browser side, this value will be used',
  },
  addBrowserCache: {
    title: 'Browser Cache',
    message: 'By default we will remove any caching on the browser side. If you want to enable browser caching set this to true. The TTL settings for the browser will be respected after this.',
  },
  headers: {
    title: 'Headers',
    message: 'Specify the headers that you want CDN to base caching on. All the headers are forwarded to origin.',
  },
  cookies: {
    title: 'Cookies',
    message: 'Select whether you want CDN to include all user cookies in the request URLs that it forwards to your origin (All), only selected cookies (Whitelist), or no cookies (None). If you select Whitelist, add the names of the cookies to the Whitelist Cookies field.',
  },
  queryStrings: {
    title: 'Query Strings',
    message: 'Select which query string parameters you want CDN to forward to the origin (all or none) and which parameters you want CDN to base caching on (a whitelist of parameters or all). We recommend that you configure CDN to cache based on parameters that have the smallest combination of possible values to reduce the number of requests that CDN must forward to the origin. ',
  },
  minimumOriginSslProtocol: {
    title: 'Minimum Origin SSL Protocol',
    message: 'Choose the minimum SSL protocol for CDN to use when it establishes an HTTPS connection to your origin. We recommend that you select the latest protocol that your server supports.',
  },
  originConnectionAttempts: {
    title: 'Origin Connection Attempts',
    message: 'The number of times that CDN attempts to connect to the origin. Valid values are from 1 to 3. The default is 3 attempts.',
  },
  originConnectionTimeout: {
    title: 'Origin Connection Timeout',
    message: 'The amount of time, in seconds, that CDN waits when trying to establish a connection to the origin. Valid values are from 1 to 10 seconds. The default is 10 seconds.',
  },
  originResponseTimeout: {
    title: 'Origin Response Timeout',
    message: 'The amount of time, in seconds, that CDN waits for a response from a custom origin. The value applies both to the time that CDN waits for an initial response and the time that CDN waits for each subsequent packet. Valid values are from 1 to 60 seconds.',
  },
  originKeepaliveTimeout: {
    title: 'Origin Keep-alive Timeout',
    message: 'The amount of time, in seconds, that CDN maintains an idle connection with a custom origin server before closing the connection. Valid values are from 1 to 60 seconds.',
  },
  httpPort: {
    title: 'HTTP Port',
    message: 'The HTTP port that the origin listens on. The default is port 80.',
  },
  httpsPort: {
    title: 'HTTPS Port',
    message: 'When you select Match Viewer for the value of Origin Protocol Policy, specify the HTTPS port that the origin listens on. The default is port 443.',
  },
  pathPattern2: {
    title: 'Path Pattern',
    message: 'Specify which requests you want to route to the origin. For example, the path pattern "images/*.jpg" routes all requests for ".jpg" files in the images directory and in all subdirectories below the images directory to the Ceph bucket or the web server that you specify in Origin.',
  },
  originOrOriginGroup: {
    title: 'Origin or Origin Group',
    message: 'The origin to which CDN routes the viewer requests specified by Path Pattern. Each cache behavior can only route requests to one origin, so you must create at least one cache behavior for every origin.',
  },
  originRequestPolicy: {
    title: 'Origin Request Policy',
    message: 'Choose an origin request policy. An origin request policy specifies the headers, query strings, and cookies that CDN includes in requests that it sends to the origin.',
  },
  httpErrorCode: {
    title: 'HTTP Error Code',
    message: 'Select the HTTP status code for which you want CDN to return a custom error response to the viewer.',
  },
  errorCachingMinimumTtl: {
    title: 'Error Caching Minimum TTL',
    message: 'The minimum amount of time (in seconds) that you want CDN to cache an error response before forwarding another request to your origin. The default time is 10 seconds.',
  },
  customizeErrorResponse: {
    title: 'Customize Error Response',
    message: 'Select whether you want CDN to return a custom error page to the viewer when your origin returns an error to CDN. If you select Yes, you must specify both Response Page Path and HTTP Response Code.',
  },
  responsePage: {
    title: 'Response Page',
    message: 'Enter the html of the custom error page for this HTTP status code.',
  },
  httpResponseCode: {
    title: 'HTTP Response Code',
    message: 'Select the HTTP status code that you want Cdn to return to the viewer along with the custom error page.',
  },
  supportedHttpVersions: {
    title: 'Supported HTTP Versions',
    message: 'For viewer requests, choose the versions of the HTTP protocol that you want GjirafaCdn to accept. In general, HTTP/2 is faster.',
  },
  defaultRootObject: {
    title: 'Default Root Object',
    message: 'Optional. The object that you want GjirafaCdn to return (for example, index.html) when a viewer request points to your root URL (http://www.example.com) instead of to a specific object in your distribution (http://www.example.com/index.html).',
  },
  comment: {
    title: 'Comment',
    message: 'Optional. Any comment about the distribution.',
  },
  distributionState: {
    title: 'Distribution State',
    message: 'When the distribution is enabled, GjirafaCdn processes viewer requests for the content associated with this distribution. When the distribution is disabled, GjirafaCdn does not accept any requests for the content associated with this distribution.',
  },
  imageOptimizer: {
    title: 'Image Optimizer',
    message: 'On-the-fly image optimization and manipulation, that automatically transforms your images for faster delivery, and bandwidth saving.',
  },
  imageOptimizerDefaultSettings: {
    title: 'Image Optimizer Default Settings',
    message: 'The default settings for the image optimizer are preconfigured parameters that are applied when optimizing images.',
  },
  waf: {
    title: 'Web Application Firewall',
    message: '<p>Captain WAF is using OWASP Core Rule Set which is an additional layer of security for your distribution that protects from the most common vulnerabilities, including the OWASP Top 10</p> <p>On - Enable WAF</p> <p>Off - Disable WAF</p> <p>Detection Only - This config tells CDN to log HTTP transactions, but takes no action when an attack is detected</p>',
  },
  instantSSL: {
    title: 'Instant SSL by Lets Encrypt',
    message: 'We provide you with an SSL certificate using Let\'s Encrypt authority. We take care of both certificate configuration and renewal. ',
  },
  noSSL: {
    title: 'No SSL certificate (not recommended)',
    message: 'Your domain will be accessible via unsecured HTTP protocol only.',
  },
  origins: {
    title: 'Origins',
    message: '<p>Origin Groups can contain only origins that are specified through an IP address. Please create two or more origins that point to your origin server through an IP address.</p> <p>Choose the origins for this group, then put them in priority order.</p>',
  },
  bucketAccess: {
    title: 'Bucket Access',
    message: '<p>If you select public bucket access, your Captain Storage bucket must allow public access.</p> <p>If you don’t want your Captain Storage bucket to allow public access, you can use the CDN with private access. With private access selected, Captain CDN sends authenticated requests to your Captain Storage bucket. This means you can block public access to your Captain Storage bucket while still allowing Captain CDN to get objects from the bucket.</p>',
  },
  originRouting: {
    title: 'Routing',
    message: '<p>Routing algorithm to use to route requests to origin group.</p> <p>Currently only Random is available. More algorithms will be available soon.</p>',
  },
  healthcheckWorkerStatus: {
    title: 'Healthchecking Status',
    message: '<p>The healthchecking status indicates if healthcheck should be going through the healthchecking process or not. The default value is Active.</p>',
  },
  healthcheckRequest: {
    title: 'Request',
    message: '<p>The request method and the path that will be polled. The default value is HEAD /.</p>',
  },
  healthcheckInitial: {
    title: 'Initial',
    message: 'The number of polls in Window that have to be successful before Varnish starts. The default value is 4.',
  },
  healthcheckThreshold: {
    title: 'Threshold & Window',
    message: '<p>Threshold is the number of polls in Window that have to be successful to consider the backend healthy. The default value is 3.</p> <p>Window is the number of polls that are examined to determine the backend health. The default value is 5.</p>',
  },
  healthcheckInterval: {
    title: 'Interval & Timeout',
    message: '<p>Interval is the polling interval. The default value is 15s.</p> <p>Timeout is the amount of time the probe is willing to wait for a response before timing out. The default value is 5s.</p>',
  },
  onfp: {
    title: 'On the fly package',
    message: '<p>When the ONFP is applied to the Behavior, the path will not be forwarded to its origin. It serves to trigger the on the fly packaging process.</p>',
  },
}
